import { render, staticRenderFns } from "./ItemSkill.vue?vue&type=template&id=71a9072e&"
import script from "./ItemSkill.vue?vue&type=script&lang=js&"
export * from "./ItemSkill.vue?vue&type=script&lang=js&"
import style0 from "./ItemSkill.vue?vue&type=style&index=0&id=71a9072e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports